



















































































































	import {Component, Prop, Vue} from 'vue-property-decorator';
	import IMessage from "@/interfaces/IMessage";
	import SingledayDateselectorModal from '@/components/SingledayDateselectorModal.vue';
	import MultidayDateselectorModal from '@/components/MultidayDateselectorModal.vue';
	import { AxiosStatic } from 'axios';

	@Component({
		components: { MultidayDateselectorModal, SingledayDateselectorModal }
	})
	export default class MessageView extends Vue {
		public $http!: AxiosStatic;

		public $refs!: {
			messageOriginalModal: any,
			messageContentIFrame: HTMLIFrameElement
		};

		@Prop({
			required: true,
			type: Object
		})
		public message!: IMessage;

		public collapsed: boolean = true;

		public showOptions: boolean = false;

		public showHeaders: boolean = false;

		public showHTML: boolean = false;

		public mounted() {
			document.addEventListener('click', () => this.closeOptions());
		}

		public closeOptions() {
			if (this.showOptions) {
				this.showOptions = false;
			}
		}

		public toggleOptions() {
			this.showOptions = !this.showOptions;
		}

		public openOriginalModal() {
			this.$refs.messageOriginalModal.show()
		}

		public async markAsUnread() {
			this.$emit('message-marked-as-unread', this.message.id);
		}

		public closeOriginalModal() {
			this.$refs.messageOriginalModal.hide()
		}

		public resetOriginalModal() {
			this.showHeaders = false;
			this.showHTML = false;
		}

		get messagedata(): any {
			if (this.message && this.message.message) {
				return JSON.parse(this.message.message);
			}
			return {};
		}

		public async onIFrameLoaded() {
			if (this.$refs.messageContentIFrame && this.$refs.messageContentIFrame.contentWindow) {
				window.addEventListener('message', event => {
					if (event.origin === 'null' && event.source === this.$refs.messageContentIFrame.contentWindow) {
						this.$refs.messageContentIFrame.style.height = (parseInt(event.data) + 10) + 'px';
						this.$refs.messageContentIFrame.setAttribute('sandbox', '');
					}
				});
				this.$refs.messageContentIFrame.contentWindow.postMessage('', '*');
			}
		}

		get html(): string {
			if (!this.messagedata || !this.messagedata.html) {
				return '';
			}
			const nonce = (Math.random() + 1).toString(36).substring(3);
			return `<html><head>
				<meta http-equiv="Content-Security-Policy" content="default-src 'none'; script-src 'nonce-${nonce}'; style-src 'unsafe-inline'; font-src data:; img-src * data">
				<script nonce="${nonce}">window.addEventListener("message", event => event.source.postMessage(document.documentElement.scrollHeight, event.origin))</${'script'}>
				</head><body>${this.messagedata.html}</body>`;
		}

		get text(): string {
			if (this.messagedata && this.messagedata.text) {
				let text = this.messagedata.text;

				// replace sendgrid links
				// text = text.replaceAll(/<https:\/\/\w+\.ct\.sendgrid\.net\/ls\/click[^>]+>/g, '');

				// replace links
 				const linkRegexp = /(\b(https?|ftp|file):\/\/([-A-Z0-9+&@#%?=~_|!:,.;]*)([-A-Z0-9+&@#%?\/=~_|!:,.;]*)[-A-Z0-9+&@#\/%=~_|])/ig;
      			text = text.replace(linkRegexp, '<a href="$1" target="_blank">$1</a>');

				return text;
			}
			return '';
		}

		get textBlocks(): any[] {
			let lastType: string | null = null;
			let lines = this.text.split("\n");
			let text: any[] = [];
			let blocks: any[] = [];
			lines.forEach((line) => {
				let type = 'normal';
				if (line.charAt(0) == '>') {
					type = 'quoted';
				}
				if (lastType !== type && lastType !== null) {
					blocks.push({
						type: lastType,
						text: text.join("\n"),
						collapsable: false
					});
					text = [];
				}
				text.push(line);
				lastType = type;
			});
			blocks.push({
				type: lastType,
				text: text.join("\n"),
				collapsable: lastType == 'quoted'
			});
			return blocks;
		}
	}
